export const CommonEnums = {
  RequiredError: "This field is required",
  ErrorPleaseTryAgain: "An error occurred. Please try again later.",
};
